const actions = {
  ZONES_ERROR: "ZONES_ERROR",
  GET_ZONES_REQUEST: "GET_ZONES_REQUEST",
  GET_ZONES_SUCCESS: "GET_ZONES_SUCCESS",
  GET_ZONE_REQUEST: "GET_ZONE_REQUEST",
  GET_ZONE_SUCCESS: "GET_ZONE_SUCCESS",
  DELETE_ZONE_REQUEST: "DELETE_ZONE_REQUEST",
  DELETE_ZONE_SUCCESS: "DELETE_ZONE_SUCCESS",
  UPDATE_ZONE_REQUEST: "UPDATE_ZONE_REQUEST",
  UPDATE_ZONE_SUCCESS: "UPDATE_ZONE_SUCCESS",
  UPDATE_ZONE_TYPE_REQUEST: "UPDATE_ZONE_TYPE_REQUEST",
  UPDATE_ZONE_TYPE_SUCCESS: "UPDATE_ZONE_TYPE_SUCCESS",
  CREATE_ZONE_REQUEST: "CREATE_ZONE_REQUEST",
  CREATE_ZONE_SUCCESS: "CREATE_ZONE_SUCCESS",
  UPDATE_ZONE_DEMAND_CONFIG_REQUEST: "UPDATE_ZONE_DEMAND_CONFIG_REQUEST",
  UPDATE_ZONE_DEMAND_CONFIG_SUCCESS: "UPDATE_ZONE_DEMAND_CONFIG_SUCCESS",
  UPDATE_ZONE_DLC_CONFIG_REQUEST: "UPDATE_ZONE_DLC_CONFIG_REQUEST",
  UPDATE_ZONE_DLC_CONFIG_SUCCESS: "UPDATE_ZONE_DLC_CONFIG_SUCCESS",
  UPDATE_ZONE_METERS_CONFIG_REQUEST: "UPDATE_ZONE_METERS_CONFIG_REQUEST",
  UPDATE_ZONE_METERS_CONFIG_SUCCESS: "UPDATE_ZONE_METERS_CONFIG_SUCCESS",
  ADD_ZONE_DATA_SOURCE_REQUEST: "ADD_ZONE_DATA_SOURCE_REQUEST",
  ADD_ZONE_DATA_SOURCE_SUCCESS: "ADD_ZONE_DATA_SOURCE_SUCCESS",
  REMOVE_ZONE_DATA_SOURCE_REQUEST: "REMOVE_ZONE_DATA_SOURCE_REQUEST",
  REMOVE_ZONE_DATA_SOURCE_SUCCESS: "REMOVE_ZONE_DATA_SOURCE_SUCCESS",

  // Local actions
  SET_SELECTED_ZONE_ID: "SET_SELECTED_ZONE_ID",

  getZones: (token, siteId) => {
    return {
      type: actions.GET_ZONES_REQUEST,
      token,
      siteId
    };
  },
  getZoneById: (token, id, siteId) => {
    return {
      type: actions.GET_ZONE_REQUEST,
      token,
      id,
      siteId
    };
  },
  deleteZone: (token, id, siteId, isSingleZone) => {
    return {
      type: actions.DELETE_ZONE_REQUEST,
      token,
      id,
      siteId,
      isSingleZone
    };
  },
  updateZone: (token, zone, siteId) => {
    return {
      type: actions.UPDATE_ZONE_REQUEST,
      token,
      zone,
      siteId
    };
  },
  updateZoneType: (token, zone, siteId, oldMainZoneId) => {
    return {
      type: actions.UPDATE_ZONE_TYPE_REQUEST,
      token,
      zone,
      siteId,
      oldMainZoneId
    };
  },
  createZone: (token, zone, siteId, isSingleZone) => {
    return {
      type: actions.CREATE_ZONE_REQUEST,
      token,
      zone,
      siteId,
      isSingleZone
    };
  },
  setSelectedZoneId: (siteId, zoneId) => {
    return {
      type: actions.SET_SELECTED_ZONE_ID,
      siteId,
      zoneId
    };
  },
  updateZoneDemandConfig: (token, siteId, zoneId, demandSwitch) => {
    return {
      token,
      type: actions.UPDATE_ZONE_DEMAND_CONFIG_REQUEST,
      siteId,
      zoneId,
      demandSwitch
    };
  },
  updateZoneDLCConfig: (token, siteId, zoneId, DLCId) => {
    return {
      token,
      type: actions.UPDATE_ZONE_DLC_CONFIG_REQUEST,
      siteId,
      zoneId,
      DLCId
    };
  },
  updateZoneMetersConfig: (token, siteId, zoneId, toggledMeterId) => {
    return {
      token,
      type: actions.UPDATE_ZONE_METERS_CONFIG_REQUEST,
      siteId,
      zoneId,
      toggledMeterId
    };
  },
  addZoneDataSource: (token, siteId, zoneId, circuitDataSourceList) => {
    return {
      type: actions.ADD_ZONE_DATA_SOURCE_REQUEST,
      token,
      siteId,
      zoneId,
      circuitDataSourceList
    };
  },
  removeZoneDataSource: (token, siteId, zoneId, circuitDataSourceList) => {
    return {
      type: actions.REMOVE_ZONE_DATA_SOURCE_REQUEST,
      token,
      siteId,
      zoneId,
      circuitDataSourceList
    };
  }
};

const zonesActions = actions;

export default zonesActions;
